namespace e5 {
    export class Animate {
        public static show(element: HTMLElement, time: number = 0.6): gs.TimelineMax {
            gs.TweenMax.killTweensOf(element);

            var tl = new gs.TimelineMax();

            element.style.display = "block";
            var currentHeight = element.offsetHeight;
            element.style.height = "auto";
            var targetHeight = element.offsetHeight;
            element.style.height = currentHeight + "px";

            tl.set(element, { height: "auto", overflow: "hidden", opacity: 1 });
            tl.set(element, { height: currentHeight, opacity: 1 }, 0.01);
            tl.to(element, time, { height: targetHeight, opacity: 1 });
            tl.set(element, { height: "auto", overflow: "visible" });
            tl.play();
            return tl;
        }

        public static hide(element: HTMLElement, time: number = 0.6): gs.TimelineMax {
            gs.TweenMax.killTweensOf(element);

            var tl = new gs.TimelineMax();
            // var op = window.getComputedStyle(element).opacity;

            element.style.display = "block";
            var currentHeight = element.offsetHeight;
            element.style.height = "auto";
            element.style.height = currentHeight + "px";

            // tl.set(element, { height: element.offsetHeight, overflow: "hidden", opacity: op, display: "block" });
            // tl.to(element, 0.6, { height: 0, opacity: 0 });
            // tl.set(element, { height: "auto", display: "none" });
            // tl.play();

            tl.set(element, { height: currentHeight, overflow: "hidden" });
            tl.to(element, time, { height: 0, opacity: 1 });
            tl.set(element, { display: "none" });
            tl.play();

            return tl;
        }

        public static toggle(element: HTMLElement, show: boolean, time: number = 0.6): gs.TimelineMax {
            if (show)
                return this.show(element, time);
            return this.hide(element, time);
        }
    }
}